import { render } from "./error-reporting.vue?vue&type=template&id=bacb628c"
import script from "./error-reporting.vue?vue&type=script&lang=js"
export * from "./error-reporting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__